import React from "react";
import Media from "@qlik/qlik/src/components/Media";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import RichText from "@qlik/qlik/src/components/RichText";
import { renderSanitizedHtmlContent } from "@qlik/qlik/src/lib/util/helpers";
import * as styles from "./styles.module.css";

/**
 * DeckTwoColumn component
 * @param {Object} data - The data for the DeckTwoColumn
 * @returns {JSX.Element} - The DeckTwoColumn component
 */
const DeckTwoColumn = ({ data }) => {
    const { cardItems = [], description, body, additionalConfiguration, backgroundColor, customId } = data ?? {};
    const sectionPaddingClassName = getSpacingClassName(additionalConfiguration, "lg:py-30");

    return (
        <section
            className={` ${sectionPaddingClassName}  ${backgroundColor === "Light" ? "bg-stone-light" : ""}`}
            id={customId}
        >
            <div className="container">
                {/* Rendering description if it exists */}
                {description?.description && (
                    <h2
                        className="title-3 text-center mb-20"
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{ __html: renderSanitizedHtmlContent(description?.description) }}
                    />
                )}
                {body?.raw && <RichText data={data} className="title-3 text-center mb-20" />}
                <div className="row gap-5 md:gap-0">
                    {/* Mapping over cardItems to render each card */}
                    {cardItems?.map((card) => (
                        <div className="md:col-6 flex" key={card?.id}>
                            {/* Rendering card icon if it exists */}
                            {card?.icon?.[0] && (
                                <Media
                                    link={card?.icon?.[0]?.secure_url}
                                    width={card?.icon?.[0]?.width}
                                    height={card?.icon?.[0]?.height}
                                />
                            )}
                            <div className="flex items-start gap-3.75 border rounded border-slate-200 bg-white p-5 pb-3 ">
                                <div>
                                    {card?.title && (
                                        <h3
                                            className={`title-5 mb-3.75 ${
                                                card.description || card.body ? "" : "md:mb-0"
                                            }`}
                                        >
                                            {card.title}
                                        </h3>
                                    )}
                                    {card?.description?.description && <p>{card.description.description}</p>}
                                    {/* Rendering card body if it exists */}
                                    {card?.body?.raw && <RichText data={card} className={`${styles.bodyContent}`} />}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default DeckTwoColumn;
